import { Link } from 'react-router-dom';

const LeadershipSection = () => {
  const executives = [
    {
      name: 'Col (R) Muhammad Anwar Chaudry',
      title: 'Chairman, Board of Directors',
      bio: 'Provides strategic oversight and governance, guiding MACGOC\'s long-term vision and institutional relationships.',
    },
    {
      name: 'Babar A. Chaudry',
      title: 'Vice Chairman, Board of Directors | President & CEO',
      bio: 'Years of experience in civil engineering, design, commercial real estate, and large-scale housing development across Dubai and Abu Dhabi. Leads enterprise strategy, market expansion, and major development initiatives.',
    },
    {
      name: 'Taimur A. Chaudry',
      title: 'Vice President | Chief Financial Officer | Member, Board of Directors',
      bio: 'Provides financial leadership, governance, and capital strategy with exceptionally strong global experience in accounting and finance.',
    },
    {
      name: 'Dr. Safwan A. Chaudry, MBBS',
      title: 'Deputy National Director | Chief Operating Officer | Member, Board of Directors',
      bio: 'Oversees operations across technology & digital services, healthcare operations & systems consulting, logistics & transportation advisory, gasoline retail & convenience store consulting, and business, finance & capital advisory.',
    },
  ];

  return (
    <section className="bg-charcoal-dark py-32">
      <div className="max-w-[1600px] mx-auto px-8">
        {/* Section Header */}
        <div className="text-center mb-20">
          <p 
            className="text-sm uppercase tracking-[0.3em] mb-6"
            style={{
              background: 'linear-gradient(90deg, #7A6A5A 0%, #C4B8A8 50%, #7A6A5A 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}
          >
            Leadership
          </p>
          <h2 className="text-4xl lg:text-5xl font-light text-white mb-6">
            Executive Team
          </h2>
          <p className="text-base text-gray-500 max-w-2xl mx-auto">
            MACGOC's strategic direction is guided by seasoned executives with decades of combined experience across engineering, healthcare, finance, and international business development.
          </p>
        </div>

        {/* Leadership Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {executives.map((executive, index) => (
            <div
              key={index}
              className="bg-black rounded-xl p-10 border border-gray-900 hover:border-copper/30 transition-all duration-300"
            >
              {/* Name */}
              <h3 className="text-2xl font-semibold text-white mb-2">
                {executive.name}
              </h3>

              {/* Title */}
              <p 
                className="text-base font-medium mb-6"
                style={{
                  background: 'linear-gradient(90deg, #A89078 0%, #C4B8A8 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                {executive.title}
              </p>

              {/* Divider */}
              <div 
                className="h-px mb-6"
                style={{
                  background: 'linear-gradient(90deg, transparent 0%, rgba(168, 144, 120, 0.3) 50%, transparent 100%)',
                }}
              ></div>

              {/* Bio */}
              <p className="text-sm text-gray-400 leading-relaxed">
                {executive.bio}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <Link
            to="/leadership"
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white px-10 py-4 text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer border border-gray-800 rounded-full hover:border-gray-700"
          >
            View Full Leadership Team
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LeadershipSection;
